// Full-course library shown on the Virtual Classroom page. Videos are added later as students enroll.
const S = (id, title, title_hi, icon, lessons) => ({ id, title, title_hi, icon, lessons });
const L = (t, min) => ({ t, min });

export const COURSE_SECTIONS = [
  S("humanoid", "Humanoid Robotics", "ह्यूमनॉइड रोबोटिक्स", "bot", [
    L("Humanoid design: DOF, balance aur centre of gravity", 32), L("Servo calibration aur smooth motion curves", 28),
    L("PCA9685 se 16 servos control karna", 35), L("Inverse kinematics: robot ka haath sahi jagah kaise pahunchta hai", 42),
    L("Biped walking gait: pehla kadam", 45), L("MPU6050 se self-balancing", 38), L("Voice commands se robot control", 33),
    L("Camera + face tracking humanoid", 40), L("Gesture-controlled robotic arm", 36), L("Capstone: welcome-robot product build", 44),
  ]),
  S("drone", "Drone Engineering", "ड्रोन इंजीनियरिंग", "plane", [
    L("Drone physics deep-dive: thrust-to-weight ratio", 30), L("Motor, propeller aur battery matching", 34),
    L("Soldering & power distribution — safely", 29), L("Flight controller firmware: ArduPilot setup", 41),
    L("PID tuning step by step", 45), L("GPS missions aur waypoint flying", 39), L("FPV camera & video transmission", 31),
    L("Agriculture spray drone concept", 37), L("DGCA rules, Digital Sky & safe operations", 26), L("Capstone: mapping & survey drone", 44),
  ]),
  S("ai", "AI & Machine Learning", "AI और मशीन लर्निंग", "brain", [
    L("AI kya hai? Real-life examples", 25), L("Python basics for AI", 40), L("Image classification with Teachable Machine", 33),
    L("Object detection on Raspberry Pi", 43), L("Speech recognition projects", 35), L("Chatbots: kaise bante hain", 31),
    L("AI ethics & safety for students", 27), L("Capstone: AI attendance camera", 45),
  ]),
  S("electronics", "Arduino & Electronics", "Arduino और इलेक्ट्रॉनिक्स", "cpu", [
    L("Voltage, current, resistance — Ohm's law with LEDs", 28), L("Breadboard mastery", 26), L("Sensors 101: IR, LDR, DHT11", 34),
    L("Motors & motor drivers (L298N)", 32), L("LCD, OLED & buzzers", 29), L("Line follower robot", 42),
    L("Obstacle-avoiding car", 38), L("Bluetooth-controlled car", 36),
  ]),
  S("aerospace", "Aerospace & CanSat", "एयरोस्पेस और CanSat", "rocket", [
    L("Rocket science basics: Newton se ISRO tak", 31), L("CanSat mission design", 37), L("Telemetry: data ko zameen par bhejna", 40),
    L("Parachute design & descent rate", 33), L("Water rocket launch lab", 35), L("Satellite orbits explained", 29),
    L("Capstone: CanSat competition build", 45),
  ]),
  S("iot", "IoT & Smart Devices", "IoT और स्मार्ट डिवाइस", "wifi", [
    L("ESP32 & WiFi basics", 30), L("Smart home switch with mobile app", 38), L("Plant-watering IoT system", 36),
    L("Weather station & cloud dashboard", 41), L("Smart school security alarm", 34),
  ]),
  S("business", "Learn & Earn: Maker Business", "लर्न एंड अर्न: मेकर बिज़नेस", "coins", [
    L("Project se product tak", 27), L("Costing, pricing aur profit", 32), L("Packaging & product photos", 25),
    L("Selling at fairs, shops & online", 30), L("Customer service & repairs", 26),
  ]),
];

export const LOCKED_COUNT = COURSE_SECTIONS.reduce((n, s) => n + s.lessons.length, 0);
